import React from 'react';
import { FiMenu, FiTarget, FiPlus, FiDollarSign } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import DarkModeToggle from './DarkModeToggle';
import UserMenu from './UserMenu';
import { useAuth } from '../context/AuthContext';

const Header = ({ onMenuClick, onAddDeal, onSetQuota }) => {
  const { isAuthenticated } = useAuth();

  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between px-4 sm:px-6 py-4">
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <SafeIcon icon={FiMenu} className="w-5 h-5 text-gray-600 dark:text-gray-300" />
          </button>
          
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-blue-600 dark:bg-blue-500 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiTarget} className="w-5 h-5 text-white" />
            </div>
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white hidden sm:block">
              Deal Tracker
            </h1>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white sm:hidden">
              Results
            </h1>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <div className="text-sm text-gray-600 dark:text-gray-300 hidden md:block">
            Sales Pipeline Quality Monitor
          </div>
          
          <div className="flex items-center space-x-2">
            <DarkModeToggle />
            
            {isAuthenticated && (
              <>
                <button
                  onClick={onSetQuota}
                  className="hidden md:flex items-center space-x-1 px-3 py-1.5 bg-green-600 dark:bg-green-500 text-white rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition-colors text-sm"
                >
                  <SafeIcon icon={FiDollarSign} className="w-4 h-4" />
                  <span>Set Quota</span>
                </button>
                
                <button
                  onClick={onAddDeal}
                  className="md:hidden p-2 bg-blue-600 dark:bg-blue-500 text-white rounded-full hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors"
                >
                  <SafeIcon icon={FiPlus} className="w-5 h-5" />
                </button>
                
                <UserMenu />
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;